import { engineRequest } from './http';

export const getSettings = () => engineRequest({ path: '/settings' });

// Partial update: send only the card's keys. Unknown keys answer 422.
export const putSettings = fields =>
  engineRequest({ method: 'put', path: '/settings', data: fields });
